<template>
  <div class="m0-page">
    <!-- Hero Section -->
    <section class="page-content">
      <div class="left-title-box">
        <p class="text_m0">m0</p>
        <p class="m0_title">Small Size<br />easy to buy</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/m0-main.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-mainx2.png'" alt="M0 Main" ref="lazyImg" />
      </div>
      <div class="scroll-mouse">
        <img src="/static/images/mouse-w.png" alt="Scroll" />
        <p>Scroll Mouse</p>
      </div>
    </section>

    <!-- Functions Section -->
    <section class="page-content">
      <div class="title-box">
        <p class="text_13">7</p>
        <p class="text-11">Functions</p>
        <p class="text-12">Small body</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/m0-function.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-functionx2.png'" alt="M0 Functions" ref="lazyImg" />
      </div>
    </section>

    <!-- Screen Section -->
    <section class="page-content">
      <div class="right-title-box">
        <p class="m0-jishen-txt">10.1<span style="font-size: 14px;">inch</span></p>
        <p class="text_21 bold-text">frameless</p>
        <p>Health data is presented graphically and<br> directly at a glance</p>
      </div>
      <div class="features-box">
        <img class="feature-img2 mobile-adjust" src="/static/images/product/m0-jishen.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-jishenx2.png'" alt="M0 Screen" ref="lazyImg" />
      </div>
    </section>

    <!-- Base Section -->
    <section class="page-content">
      <div class="left-title-box m0-font-color">
        <p class="text_21 bold-text">Suspension <br>base</p>
        <p>Suspension round corner tempered glass, <br>with slim body, minimalist fashion.</p>
      </div>
      <div class="features-box">
        <img class="feature-img mobile-adjust" src="/static/images/product/m0-dizuo.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-dizuox2.png'" alt="M0 Base" ref="lazyImg" />
      </div>
    </section>

    <!-- Design Section -->
    <section class="page-content" style="background-color: #FE5C00;">
      <div class="row">
        <div class="col-lg-6">
          <div class="features-box" style="top: 0;">
            <img class="feature-img mobile-adjust" src="/static/images/product/m0-jishenxq.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-jishenxqx2.png'" alt="M0 Design" ref="lazyImg" />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="left-title-box">
            <p class="text_21 bold-text">One piece design <br>Seamless</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Light Strip Section -->
    <section class="page-content">
      <div class="left-title-box m0-font-color">
        <p class="text_21 bold-text">The finishing <br>touch</p>
        <p>Family light strip Appearance level play</p>
      </div>
      <div class="features-box" style="top: 0;">
        <img class="feature-img2 mobile-adjust" src="/static/images/product/m0-jishenxq2.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-jishenxq2x2.png'" alt="M0 Light Strip" ref="lazyImg" />
      </div>
    </section>

    <!-- Sensor Section -->
    <section class="page-content">
      <div class="rightM-title-box m0-font-color">
        <p class="text_21 bold-text">Horizontal <br>wave sensor</p>
        <p>Accurately measure the weight per gram of the <br>
        human body and the resistivity change per ohm to <br>
        ensure the accuracy and stability of the <br>
        measurement results</p>
      </div>
      <div class="features-box" style="top: 0;">
        <img class="feature-img mobile-adjust" src="/static/images/product/m0-dizuoxq.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-dizuoxqx2.png'" alt="M0 Sensor" ref="lazyImg" />
      </div>
    </section>

    <!-- Bluetooth Printing Section -->
    <section class="page-content">
      <div class="left-title-box">
        <div class="icon-list">
          <img src="/static/images/product/Bluetooth.png"/>
          <div class="divider"></div>
          <img src="/static/images/product/Print.png"/>
          <div class="divider"></div>
          <img src="/static/images/product/checkmark.png"/>
        </div>
        <p class="text_21 bold-text" style="color: #FE5C00;">Bluetooth <br>printing</p>
      </div>
      <div class="features-box" style="top: 0;">
        <img class="feature-img mobile-adjust" src="/static/images/product/m0-tcbg.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/m0-tcbgx2.png'" alt="M0 Bluetooth" ref="lazyImg" />
      </div>
    </section>

    <!-- Management System Section -->
    <section class="page-content" style="background-color: #FFFFFF;">
      <div class="m1-csbg-title" style="color: black;">
        PC background <br>management system
      </div>
      <div class="features-box">
        <img class="feature-img2 mobile-adjust" src="/static/images/product/m0-glht.png" :data-src="'https://zhaiker.oss-cn-hangzhou.aliyuncs.com/anovator/image/n0-glhtx2.png'" alt="M0 Management" ref="lazyImg" />
      </div>
    </section>

    <!-- 3D Product View Section -->
    <div class="product-3d-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <h2 class="section-title text-center" style="text-transform: uppercase;">M0 3D Product View</h2>
            <div class="iframe-container">
              <iframe 
                id="product-3d-iframe"
                src="/static/web/m0/m0.html" 
                width="100%" 
                height="700px" 
                frameborder="0"
                class="product-iframe"
              ></iframe>
              <p class="iframe-desc">Drag to rotate • Double-click for fullscreen</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Technical Specifications Section -->
    <div class="tech-specs-section">
      <div class="container">
        <div class="tb-title">
          TECHNICAL SPECIFICATIONS:
        </div>
        <table class="tb technical-tb">
          <tr v-for="(spec, index) in technicalSpecs" :key="index">
            <td class="tb-key">{{ spec.left }}</td>
            <td class="tb-key">{{ spec.right }}</td>
          </tr>
        </table>
        
        <h4 style="margin-top: 50px;margin-bottom: 20px;color: #FFFFFF;">M0 Body Composition Analyzer</h4>
        <table class="tb product-parameters">
          <tr v-for="param in productParams" :key="param.category + param.label">
            <td v-if="param.isCategory" class="tb-col1" :rowspan="param.rowspan">{{ param.category }}</td>
            <td class="tb-col2">{{ param.label }}</td>
            <td class="tb-col3" v-html="param.value"></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'M0',
  data() {
    return {
      technicalSpecs: [
        { left: 'User ID Login/Phone Number Login', right: 'On Screen Results' },
        { left: 'Printable Results', right: 'Handle Grips' },
        { left: 'Weight', right: 'BMI' },
        { left: 'Body Fat Percentage', right: 'Muscle Mass' },
        { left: 'Visceral Fat Area', right: 'Subcutaneous Fat Area' },
        { left: 'Protein Content', right: 'Total Body Water' },
        { left: 'Skeletal Muscle', right: 'Fat-Free Body' },
        { left: 'Bone Mass', right: 'WHR' },
        { left: 'Body Age', right: 'BMR(kcal)' },
        { left: 'Obesity Degree (%)', right: 'Desirable Weight' },
        { left: 'Weight Control', right: 'Fat Control' },
        { left: 'Muscle Control', right: 'Segmental Muscle' },
        { left: 'Segmental Body Fat', right: 'Body Type Classification' },
        { left: 'Body Posture Analysis', right: 'Total Energy Expenditure (kcal)' },
        { left: 'Calorie Consumption (kcal/hour)', right: 'Expected Fat Burning (kg)' },
        { left: 'Target Body Fat', right: 'Exercise Program Advice' },
        { left: 'Estimated Completion Period', right: 'Body Composition History' },
        { left: 'Pervious Data Comparison', right: '' }
      ],
      productParams: [
        { isCategory: true, category: 'Screen Host', rowspan: 6, label: 'Brand', value: 'Anovator' },
        { isCategory: false, label: 'Product Name', value: 'Body Composition Analyzer' },
        { isCategory: false, label: 'Model', value: 'M0' },
        { isCategory: false, label: 'Color', value: 'White' },
        { isCategory: false, label: 'Operating System', value: 'Android 11' },
        { isCategory: false, label: 'Material', value: 'Tempered Glass Led Screen + Aluminum Alloy' },
        { isCategory: true, category: 'Size & Weight', rowspan: 3, label: 'Product Size', value: 'Host: 1210mm*750mm*450mm' },
        { isCategory: false, label: 'Package Size', value: '125*755*55cm' },
        { isCategory: false, label: 'Weight', value: '25KG' },
        { isCategory: true, category: 'Display Screen', rowspan: 2, label: 'Screen Size', value: '10.1 Inch' },
        { isCategory: false, label: 'Screen Type', value: '800*1280 IPS HD Touch' },
        { isCategory: true, category: 'Technical Parameters', rowspan: 4, label: 'Measurement methods', value: '8-point contact electrodes, multi-frequency bioelectrical impedance analysis technology' },
        { isCategory: false, label: 'Frequency', value: '20,100 kHz' },
        { isCategory: false, label: 'Electric Current', value: '<280uA' },
        { isCategory: false, label: 'Power consumption', value: '15W' },
        { isCategory: true, category: 'Function parameter', rowspan: 8, label: 'Report', value: 'Phone/Paper Print Report/Web' },
        { isCategory: false, label: 'Voltage', value: 'Input: AC 220V，50/60Hz <br />Output：DC 12V,7A' },
        { isCategory: false, label: 'Transmission Port', value: 'USB2.0/Bluetooth/Wired/Wireless' },
        { isCategory: false, label: 'Height Range', value: '80-200cm' },
        { isCategory: false, label: 'Weight Range', value: '0-200kg' },
        { isCategory: false, label: 'Age Range', value: '3-99 years old' },
        { isCategory: false, label: 'Operating Environment', value: 'Internet Connection Required <br />Temperature: 10-40℃, Humidity: 30%-75% <br />Do not place the device by the window to avoid direct sunlight.<br />Do not shine direct light on the device screen.<br />Do not hit the device hard.' },
        { isCategory: false, label: 'Save the environment', value: 'Temperature: -20~70℃, Humidity: ≤95%' }
      ]
    }
  },
  mounted() {
    document.title = 'anovator | M0 body composition analyzer';
    
    // 初始化图片懒加载
    this.initLazyLoading();
    
    // 3D iframe responsive handling
    let resizeTimeout;
    const handle3DResize = () => {
      const iframe = document.getElementById('product-3d-iframe');
      if (iframe) {
        const src = iframe.src;
        iframe.src = '';
        setTimeout(() => {
          iframe.src = src;
        }, 100);
      }
    };
    
    const debouncedResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handle3DResize, 500);
    };
    
    window.addEventListener('resize', debouncedResize);
    window.addEventListener('orientationchange', function() {
      setTimeout(debouncedResize, 500);
    });
  },
  beforeUnmount() {
    // Clean up event listeners
    window.removeEventListener('resize', this.debouncedResize);
    window.removeEventListener('orientationchange', this.debouncedResize);
  },
  methods: {
    initLazyLoading() {
      // 获取所有带有data-src属性的图片
      const lazyImages = document.querySelectorAll('img[data-src]');
      
      if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              const dataSrc = img.getAttribute('data-src');
              if (dataSrc) {
                img.src = dataSrc;
                img.removeAttribute('data-src');
                observer.unobserve(img);
              }
            }
          });
        });
        
        lazyImages.forEach(img => imageObserver.observe(img));
      } else {
        // 降级处理：直接加载所有图片
        lazyImages.forEach(img => {
          const dataSrc = img.getAttribute('data-src');
          if (dataSrc) {
            img.src = dataSrc;
            img.removeAttribute('data-src');
          }
        });
      }
    }
  }
}
</script>

<style scoped>
.m0-page {
  background-color: #FFFFFF;
}

.page-content {
  position: relative;
  width: 100vw;
}

.features-box {
  width: 100%;
  height: 100%;
}

.feature-img {
  display: block;
  width: 100vw;
  height: calc(100vh - 90px);
  object-fit: cover;
  object-position: center;
  margin: 0;
  padding: 0;
}

.feature-img2 {
  display: block;
  width: 100vw;
  object-fit: cover;
  object-position: center;
  margin: 0;
  padding: 0;
}

.title-box {
  position: absolute;
  width: 100%;
  top: 9vh;
  text-align: center;
  z-index: 10;
}

.left-title-box {
  position: absolute;
  left: 20%;
  bottom: 45%;
  z-index: 10;
}

.right-title-box {
  position: absolute;
  right: 25%;
  top: 30%;
  z-index: 10;
}

.rightM-title-box {
  position: absolute;
  right: 10%;
  bottom: 40%;
  z-index: 10;
  padding-left: 20px;
}

.bold-text {
  font-weight: 600;
  font-size: 45px !important;
  line-height: 55px !important;
  text-transform: uppercase;
}

.text_m0 {
  overflow-wrap: break-word;
  color: rgba(254, 92, 0, 1);
  font-size: 50px;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 55px;
  text-transform: uppercase;
  margin-bottom: 0;
}

.m0_title {
  color: rgba(0, 0, 0, 1);
  font-size: 35px;
  text-transform: uppercase;
  font-weight: 700;
  font-family: MiSans-Bold;
  text-align: left;
}

.text_13 {
  overflow-wrap: break-word;
  color: rgba(254, 92, 0, 1);
  font-size: 7vw;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
}

.text-11 {
  position: relative;
  color: rgba(90, 59, 59, 1);
  text-transform: uppercase;
  font-family: MiSans-Regular;
  font-size: 0.8vw;
  margin-bottom: 0;
  top: -6vh;
}

.text-12 {
  font-size: 2vw;
  text-transform: uppercase;
  color: #000000;
  font-family: MiSans-Bold;
}

.text_21 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 3.33vw;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  white-space: normal;
  line-height: 4.45vw;
}

.m0-jishen-txt {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 6.66vw;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
}

.icon-list {
  display: flex;
  margin-bottom: 20px;
}

.icon-list img {
  width: 80px;
}

.divider {
  position: relative;
  width: 55px;
  height: 3px;
  margin: 5px 10px;
  background-color: #DCDCDC;
  top: 35px;
}

.m1-csbg-title {
  position: relative;
  width: 100%;
  text-align: center;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 2.5vw;
  text-transform: uppercase;
  font-family: MiSans-Bold;
  font-weight: 700;
  white-space: normal;
  line-height: 3.5vw;
  z-index: 10;
  top: 28vh;
}

.scroll-mouse {
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.scroll-mouse img {
  width: 30px;
  height: 30px;
}

.scroll-mouse p {
  color: #FFFFFF;
  font-size: 12px;
  margin-top: 10px;
}

.product-3d-section {
  background-color: #f8f9fa;
  padding: 60px 0;
  margin-top: 150px;
  margin-bottom: 0;
}

.section-title {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
  font-weight: bold;
}

.iframe-container {
  background: white;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  padding: 20px;
  margin: 0 auto;
}

.product-iframe {
  border: none;
  border-radius: 10px;
  min-height: 300px;
}

.iframe-desc {
  text-align: center;
  margin-top: 15px;
  color: #666;
  font-size: 14px;
}

.tech-specs-section {
  background-color: #000000;
  padding-bottom: 10px;
}

.tb-title {
  width: 100%;
  height: 300px;
  padding-top: 230px;
  font-size: 30px;
  font-weight: 600;
  color: #FFFFFF;
  line-height: 35px;
}

.tb {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-bottom: 50px;
  color: #FFFFFF;
}

.tb th, .tb td {
  border: 1px solid #3F3F3F;
  padding: 15px;
}

.tb tr {
  height: 40px;
}

.tb-key {
  width: 50%;
  background-image: url('../../../public/static/images/checkmark.png');
  background-repeat: no-repeat;
  background-size: 22px;
  background-position-y: 50%;
  background-position-x: 97%;
  padding-right: 30px;
}

.tb-col1 {
  width: 20%;
  font-weight: 600;
  text-align: center;
}

.tb-col2 {
  width: 30%;
  text-align: left;
}

.tb-col3 {
  width: 50%;
  text-align: left;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .features-box{
    margin-top: 0;
  }
  .left-title-box {
    left: 10%;
    bottom: 35%;
  }
  .title-box{
    top: 30vh;
  }
  .mobile-adjust{
    height: 100vh;
  }
  .right-title-box {
    right: 10%;
    top: 25%;
  }
  .feature-img2{
    height: auto;
  }
  
  .rightM-title-box {
    right: 5%;
    bottom: 30%;
    padding-left: 10px;
  }
  
  .text_m0 {
    font-size: 35px;
  }
  
  .m0_title {
    font-size: 25px;
  }
  
  .text_13 {
    font-size: 50px;
  }
  
  .text-11 {
    font-size: 12px;
    top: 0;
  }
  
  .text-12 {
    font-size: 20px;
  }
  
  .text_21 {
    font-size: 5vw;
    line-height: 6vw;
  }
  
  .m0-jishen-txt {
    font-size: 8vw;
  }
  
  .bold-text {
    font-size: 30px !important;
    line-height: 35px !important;
  }
  
  .icon-list img {
    width: 60px;
  }
  
  .divider {
    width: 40px;
    top: 25px;
  }
  
  .m1-csbg-title {
    font-size: 4vw;
    line-height: 5vw;
    top: 10vh;
  }
  
  .product-3d-section {
    padding: 40px 0;
    margin-top: 20vh;
  }
  
  .iframe-container {
    padding: 15px;
    margin: 0 10px;
  }
  
  .product-iframe {
    height: 400px !important;
    min-height: 300px !important;
  }
  
  .tb-title {
    height: 200px;
    padding-top: 150px;
    font-size: 20px;
  }
  
  .tb th, .tb td {
    padding: 10px;
    font-size: 12px;
  }
  
  .tb-key {
    background-size: 16px;
    padding-right: 20px;
  }
}

/* Small mobile devices */
@media (max-width: 480px) {
  .product-3d-section {
    padding: 40px 0;
  }
  
  .product-iframe {
    height: 350px !important;
    min-height: 250px !important;
  }
}

/* Landscape orientation on mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .product-3d-section {
    padding: 20px 0;
  }
  
  .product-iframe {
    height: 300px !important;
    min-height: 200px !important;
  }
  
  .iframe-container {
    margin: 0 20px;
  }
}

/* 4K and large screen optimization */
@media (min-width: 1920px) {
  .feature-img, .feature-img2 {
    width: 100vw !important;
    max-width: none !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
  
  .features-box {
    width: 100vw !important;
    margin-left: calc(-50vw + 50%) !important;
    margin-right: calc(-50vw + 50%) !important;
  }
}
</style>